import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  rechercheContainer: {
    flexDirection: 'row',
    marginRight: 20,
    marginTop: 20,
    marginLeft: 20,
  },
  rechercheTextInput: {
    marginLeft: 10,
    flex: 1,
  },

  label: {
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  mainTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: 'rgba(15, 87, 158, 1)',
    marginTop: 24,
    marginBottom: 8,
  },
  secondTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#000',
  },
  thirdTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#000',
  },
  titleGreen: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    minHeight: 25,
    marginTop: 16,
  },
  titleGreenCross: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    marginTop: 20,
  },
  titleGreenCenter: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    textAlign: 'center',
  },
  titleGreen14: {
    fontSize: 14,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen11: {
    fontSize: 11,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen12: {
    fontSize: 12,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen13: {
    fontSize: 13,
    fontWeight: '700',
    color: '#1D5C42',
  },
  paragraph: {
    fontSize: 16,
    fontWeight: '400',
    color: '#000',
    marginVertical: 16,
  },
  paragraph14: {
    fontSize: 14,
    fontWeight: '400',
    color: '#000',
    marginVertical: 8,
  },
  textItalic: {
    fontStyle: 'italic',
    color: 'gray',
    marginTop: -5,
  },
  link: {
    fontSize: 16,
    fontWeight: '700',
    color: '#58A618',
    marginVertical: 16,
  },
  error: {
    fontSize: 14,
    fontWeight: '400',
    color: '#F00',
  },
  linkblue: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F579E',
    marginVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#0F579E',
  },
  linkUnderline: {
    fontSize: 16,
    fontWeight: '400',
    color: '#58A618',
    marginVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#58A618',
  },
});
